import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackImportPatientsDownloadExampleClick = (userId?: string): void => {
  trackingService.trackEvent(
    'DOWNLOAD',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'importar pacientes',
      step: 'baixar exemplo',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackImportPatientsCancelClick = (userId?: string): void => {
  trackingService.trackEvent(
    'CANCEL',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'importar pacientes',
      step: 'cancelar',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackImportPatientsConfirmClick = (userId?: string): void => {
  trackingService.trackEvent(
    'IMPORT',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'importar pacientes',
      step: 'confirmar',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackImportPatientsFinishClick = (userId?: string): void => {
  trackingService.trackEvent(
    'FINISH',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'importar pacientes',
      step: 'concluir',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
